export default "__VITE_ASSET__VLNhF_y6__"